import { projectManagementRouter } from "@/routers/purchaseSalesInventory/projectManagement";
import purchasingManageRouter from "@/routers/purchaseSalesInventory/purchasingManage";
import salesManageRouter from "@/routers/purchaseSalesInventory/salesManage";
import { contractRouter } from "@/routers/purchaseSalesInventory/contract";
import { fundRouter } from "@/routers/purchaseSalesInventory/fund";
import financingRouter from "@/routers/purchaseSalesInventory/financing";
import receivableRouter from "@/routers/purchaseSalesInventory/receivable";
import invoiceRouter from "@/routers/purchaseSalesInventory/invoice";
import { storageRouter } from "@/routers/purchaseSalesInventory/storage";
import logisticsRouter from "@/routers/purchaseSalesInventory/logistics";
import statementStatisticsRouter from "@/routers/purchaseSalesInventory/statementStatistics";
import { ROLE_TYPE } from "@supplier/meta";
import { UserStore } from "@/stores/modules/user.ts";

export const purchaseSalesInventoryRouters = [
    {
        path: "/purchaseSalesInventory",
        name: "PurchaseSalesInventory",
        meta: {
            title: "进销存管理",
            icon: "icon-jinxiaocun",
            hidden: ({ userStore }: { userStore: UserStore }) => {
                // 进销存管理和仓储业务根据企业身份展示，拥有进销存企业身份。
                return userStore.isSAAS && !userStore.userInfo.supplier?.roles?.includes(ROLE_TYPE.INVENTORY_MANAGEMENT.code);
            }
        },
        children: [
            ...projectManagementRouter,
            ...purchasingManageRouter,
            ...salesManageRouter,
            ...contractRouter,
            ...fundRouter,
            ...financingRouter,
            ...receivableRouter,
            ...invoiceRouter,
            ...logisticsRouter,
            ...storageRouter,
            ...statementStatisticsRouter
        ]
    }
];
